/* 财务模块API */

import { GET, POST, download, uploading, POSTFormData } from '@/request/http'

//基础-职位设置
export const pageJobRoyalty = p => POST('/financial/jobroyalty/pagejobroyalty', p)
export const saveorupdatejobroyalty = p => POST('/financial/jobroyalty/saveorupdate', p)
export const removejobroyalty = p => POST('/financial/jobroyalty/remove', p)
export const listJobUsers = p => POST('/financial/jobroyalty/listJobUsers', p)
export const listJobUsersSelected = p => POST('/financial/jobroyalty/listJobUsersSelected', p)
export const setJobUsers = p => POST('/financial/jobroyalty/setJobUsers', p)

//查看营销月报
export const listLocationIncome = p => POST('/financial/locationincome/listLocationIncome', p)
export const saveLocationIncome = p => POST('/financial/locationincome/saveLocationIncome', p)

//查看任务
export const listCommitment = p => POST('/financial/commitment/listCommitment', p)
export const saveCommitment = p => POST('/financial/commitment/saveCommitment', p)

//测算明细
export const listlocationcalculation = p => POST('/financial/locationcalculation/listlocationcalculation', p)
export const createLocationCalculation = p => POST('/financial/locationcalculation/createLocationCalculation', p)

//季度提成
export const listquarterroyalty = p => POST('/financial/quarterroyalty/list', p)



// WEBPACK FOOTER //
// ./src/api/modules/finance.js